import { render, staticRenderFns } from "./standardFileList.vue?vue&type=template&id=c1416f12&scoped=true&"
import script from "./standardFileList.vue?vue&type=script&lang=js&"
export * from "./standardFileList.vue?vue&type=script&lang=js&"
import style0 from "./standardFileList.vue?vue&type=style&index=0&id=c1416f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1416f12",
  null
  
)

export default component.exports